import { render, staticRenderFns } from "./KWEkle.vue?vue&type=template&id=a86897ca&scoped=true&"
import script from "./KWEkle.vue?vue&type=script&lang=js&"
export * from "./KWEkle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86897ca",
  null
  
)

export default component.exports